/**
 * Shared utilities for Action Items components
 */

/**
 * Map a ClientStatus::Name value or action item category to a Badge color.
 * @param status - ClientStatus::Name string (e.g. 'outreach_ongoing') or action item category.
 *                 outreach/intake funnel → sky, care/near-graduation → indigo,
 *                 discharged/declined/ended → lavender, ready_for_assignment → mint.
 * @returns Badge color variant
 */
export function getBadgeColor(
  status: string
): 'sky' | 'mint' | 'gold' | 'orange' | 'indigo' | 'lavender' | 'white' {
  switch (status) {
    case 'ready_for_assignment':
      return 'mint'
    case 'care_ongoing':
    case 'care_ongoing_with_partner':
    case 'near_graduation':
      return 'indigo'
    case 'graduated':
    case 'pending_discharge':
    case 'unreachable_during_outreach':
    case 'unreachable_during_intake':
    case 'services_declined_by_cartwheel_during_outreach':
    case 'services_declined_by_client_during_outreach':
    case 'services_declined_by_cartwheel_during_intake':
    case 'services_declined_by_client_during_intake':
    case 'services_ended_by_cartwheel_during_care':
    case 'services_ended_by_client_during_care':
    case 'services_on_pause':
    case 'referred_to_partner':
    case 'partner_services_ended':
    case 'services_declined_by_partner':
      return 'lavender'
    default:
      // Covers: first_outreach_pending, outreach_ongoing, cost_confirmation_needed,
      // cost_under_family_review, cost_estimate_pending, self_schedule_pending,
      // internal_review_needed, partner_referral_pending, clinician_assigned,
      // intake_scheduled, intake_cancelled, intake_no_show
      return 'sky'
  }
}

/**
 * Format action item category for display
 * @param category - Snake_case category string from API
 * @returns Formatted title case string (e.g., "Ready For Assignment")
 * @example
 * formatCategory('ready_for_assignment') // Returns: "Ready For Assignment"
 */
export function formatCategory(category: string): string {
  if (category === 'self_schedule_pending') return 'Self-schedule pending'
  return category
    .split('_')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ')
}
